import React from "react";
import BilingualInvoicePrint from "../../../components/invoice/BilingualInvoicePrint";

const PrintInvoice: React.FC = () => <BilingualInvoicePrint kind="order" />;

export default PrintInvoice;
